var __jsx = React.createElement;
import React from "react";
import dynamic from "next/dynamic";
import Head from "next/head";
import { observer } from "mobx-react-lite";
import { PageLayout } from "../../util/constants";
import { useStore } from "@dp/state";
import { useRouter } from "next/router";
var LiveMusic = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.LiveMusic;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var LiveMusicPage = function LiveMusicPage(props) {
  var _router$query;
  var store = useStore();
  var router = useRouter();
  var restaurantNumber = router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.setRestaurant;
  React.useEffect(function () {
    var _store$user;
    store === null || store === void 0 || store.initComponent("LiveMusic").then()["catch"](function (error) {
      //
    });
    store === null || store === void 0 || (_store$user = store.user) === null || _store$user === void 0 || (_store$user = _store$user.analyticsModel) === null || _store$user === void 0 || _store$user.dispatchPageViewEvent();
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, "Live Music")), __jsx(LiveMusic, {
    restaurantNumber: restaurantNumber
  }));
};
LiveMusicPage.layout = PageLayout.DP_LAYOUT;
LiveMusicPage.layoutProps = {
  analyticsData: {
    pageName: "live-music",
    pageType: "live-music",
    primaryCategory: "Live Music"
  }
};
export default observer(LiveMusicPage);